import React, { useEffect, useState } from 'react';

import { debounce } from 'lodash-es';
import { injectIntl, InjectedIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import SearchField from 'src/components/search-field';
import { changeFilterState } from 'src/redux/jira/actions';
import { FilterState } from 'src/redux/jira/types';
import { BucketState } from 'src/types/state';

import messages from './text-search-filter.i18n';

type TextSearchFilterProps = {
  intl: InjectedIntl;
};

const debouncedDispatch = debounce(
  (dispatch, search) =>
    dispatch(
      changeFilterState({
        textFilterQuery: search,
      })
    ),
  400
);

export const TextSearchFilter = injectIntl((props: TextSearchFilterProps) => {
  const { intl } = props;
  const filterState = useSelector<BucketState, FilterState>(
    state => state.jira.jiraRepoPage.filterState
  );
  const { textFilterQuery } = filterState;
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState(textFilterQuery);

  useEffect(() => {
    setInputValue(textFilterQuery);
  }, [textFilterQuery]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    debouncedDispatch(dispatch, e.target.value);
  };

  const clearFilter = () => {
    setInputValue('');
    debouncedDispatch(dispatch, '');
  };

  return (
    <SearchField
      fieldName="search-issues-input"
      currentSearch={inputValue}
      handleFilterChange={onChange}
      clearFilter={clearFilter}
      placeholder={intl.formatMessage(messages.textSearchFilterPlaceholder)}
    />
  );
});
